"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccumulationThresholds = getAccumulationThresholds;
const adapter_1 = require("../thresholds/adapter");
/**
 * The on-site accumulation thresholds for a facility, answered by the jurisdiction class for its
 * state through the same registry the area rules dispatch through.
 * Both status axes ride back on the result exactly as passed.
 */
function getAccumulationThresholds(query) {
    const { state, ...ctx } = query;
    return { ...(0, adapter_1.resolveAccumulationThresholds)(state, ctx), ...ctx };
}
//# sourceMappingURL=getOnSiteAccumulationThresholds.js.map